import React from 'react';

// Packages
import { Text, View } from '@react-pdf/renderer';
import PropTypes from 'prop-types';

// Components
import PDFImage from '../utils/PDFImage';

// Styles
import { styles, colors } from './styles';

// Utils
import formatString from '../../../utils/formatString';
import isObjectId from '../../../utils/isObjectId';

const PayloadContent = (props) => {
	const { parsedPayload } = props;

	return (
		<View>
			<View style={styles.section}>
				<Text style={styles.sectionText}>Contenido del Censo</Text>
			</View>
			<View style={styles.tableContentHeader}>
				<View style={{ padding: 2, width: '18.8%' }}>
					<Text style={styles.boldTex}>Tipo</Text>
				</View>
				<View style={{ padding: 2, width: '18.8%' }}>
					<Text style={styles.boldTex}>Información</Text>
				</View>
				<View style={{ padding: 2, width: '60%'}}>
					<Text style={styles.boldTex}>Imágenes</Text>
				</View>
			</View>
			<View>
				{parsedPayload.length > 0
					? parsedPayload.map((element, idx) => (
						<View key={idx}>
							{Object.keys(element).map((key, i) => (
								<View style={styles.tableContentRow} key={i}>
									<View style={styles.tableContentNameCell}>
										<Text style={styles.boldTex}>{formatString(key)}</Text>
									</View> 
									<View style={styles.tableContentInfoCell}>
										{typeof element[key] === 'object'
											? <View>
													{element[key].items.map((item, itemIdx) => (
														<View key={itemIdx}>
															{Object.entries(item).map(([itemKey, value]) => (
																<Text key={itemKey} style={styles.normalText}>{formatString(itemKey)}: {value}</Text>
															))}
														</View>
													))}
												</View>
											: !isObjectId(element[key]) && <Text style={styles.normalText}>{element[key]}</Text> 
										}
									</View>
									<View style={styles.tableContentCell}>
										{typeof element[key] === 'object'
											? <View style={{ ...styles.tableContentCell, ...styles.flexWrap }}>
													{element[key].photos.map((item, photoIdx) => (
														<View key={photoIdx} style={styles.tableColumn}>
															{Object.entries(item).map(([itemKey, value]) => (
																<View key={itemKey}>
																	{itemKey === 'image' 
																		? <PDFImage imageId={value} />
																		: <Text style={styles.normalText}>
																				{itemKey === 'image' ? null : formatString(itemKey) + ': '}{value}
																			</Text>
																	}
																</View>
															))}
														</View>
													))}
												</View>
											: isObjectId(element[key]) && <PDFImage imageId={element[key]} />
										}
									</View>
								</View>
							))}
						</View>
					))
					: <View>
							<Text style={styles.boldTex}>No hay contenido</Text>
						</View>
				}
			</View>
		</View>
	);
}

PayloadContent.prototypes = {
	colors: PropTypes.object.isRequired,
	parsedPayload: PropTypes.array.isRequired
}

export default PayloadContent;